import { getIdToken } from './firebase.js';

async function req(path, init = {}) {
  const token = await getIdToken();
  if (!token) throw new Error('not_signed_in');
  const res = await fetch(path, {
    ...init,
    headers: {
      ...(init.headers || {}),
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
  if (!res.ok) {
    const body = await res.text();
    throw new Error(`${res.status}: ${body}`);
  }
  return res.json();
}

export const api = {
  getState:        () => req('/api/state'),
  sendMessage:     (text) => req('/api/message', { method: 'POST', body: JSON.stringify({ text }) }),
  note:            (text) => req('/api/note', { method: 'POST', body: JSON.stringify({ text }) }),
  takeBack:        (timestamp) => req('/api/take-back', { method: 'POST', body: JSON.stringify({ timestamp }) }),
  respawn:         () => req('/api/respawn', { method: 'POST', body: JSON.stringify({}) }),
  shareCard:       (text, urgent) => req('/api/share-card', { method: 'POST', body: JSON.stringify({ text, urgent }) }),
  removeShareCard: (id) => req(`/api/share-card/${encodeURIComponent(id)}`, { method: 'DELETE' }),
};
